import { clearError } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import { useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { AppConstatnt } from "../../../../../Utils/AppConstant";
import { currencyConvertor, getControlNumber, getTheme, isEclipseOpsTruck } from "../../../../../Utils/Utility";
import ErrornDialog from "../../../../Common/ErrorDialog/ErrorDialog";
import LoaderButton from "../../../../Common/LoaderButton";
import TransactionDialog from "../../../../Common/TransactionDialog";
import BilledHeader from "../BilledHeader";
import Tooltip from '@mui/material/Tooltip';

function PaymentMethod({ intl, loading, onSubmitClick, error, errorresponse, transactionId, title, paymentCodeName, amount, remainingAmount, selection, id, length, paymentType, message, total_bill_amount, paymentmethods, serviceFee, originalAmount }) {

    const [paymentData, setpaymentData] = useState({ val1: "", val2: "" });
    const [valid, setValid] = useState(false);
    const [show, setShow] = useState(false);
    const [errorStatus, setErrorStatus] = useState('');
    const [tip1show, settip1Show] = useState(false);
    const dispatch = useDispatch();
    const [isValid, setIsValid] = useState(false);
    const themeStyle = getTheme() === AppConstatnt.theme.DARK ? 'light' : '';
    const { formatMessage } = intl;
    const loads = useSelector(state => state.billed.billedPo.loads);
    const load = loads.find(load => load.load_id === id);

    useEffect(() => {
        dispatch(clearError());
    }, []);

    function handleChange(e) {
        setpaymentData({
            ...paymentData,
            [e.target.name]: e.target.value
        });

    }



    function handleSubmit() {
        onSubmitClick(paymentData);
    }

    const getAmount = () => {
        if (isEclipseOpsTruck(load)) {
            return parseFloat(amount) - parseFloat(serviceFee)
        } else {
            return originalAmount

        }
    }

    return (
        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <BilledHeader path={`/paymentconfirmation/${id}`} amount={getAmount()} remainingAmount={remainingAmount} selection={selection} total_bill_amount={total_bill_amount} paymentmethods={paymentmethods} />
                    <div className="container_block" style={{ padding: '40px' }}>
                        <div id="smartwizard" className="sw sw-theme-dots sw-justified">
                            <div className="row">
                                {show &&
                                    <div className="col-md-8">
                                        <Alert variant="danger" onClose={() => setShow(false)} dismissible >
                                            {errorStatus}
                                        </Alert>
                                    </div>
                                }
                            </div>
                            <section id="relayPayment_hide">
                                <h4 className="mb-3 txtwhite">{title}</h4>
                                <p>{formatMessage({ id: "app.total_amount_to_pay" })} <strong className="remaining_amt">${amount}</strong></p>
                                <div className="row mt-4">
                                    <div className="col-4">
                                        <div className="form-group">
                                            <label htmlFor="relayPaymentCode">{paymentCodeName}</label>
                                            <Tooltip title={formatMessage({ id: "app.relay_payment_tooltip" }, { length: length })} enterTouchDelay={0} arrow>
                                                <input type="text" name="val1" id="relayPaymentCode"
                                                    className="form-control" placeholder={`${formatMessage({ id: "app.enter" })} ${paymentCodeName}`} onChange={handleChange} onClick={() => settip1Show(true)} />
                                            </Tooltip>
                                        </div>
                                    </div>



                                    {transactionId && <TransactionDialog
                                        transactionId={transactionId}
                                        statusMessage={`${paymentCodeName} ${formatMessage({ id: "app.payment_submitted_successfully" })}`}
                                        open
                                        id={id}
                                        paymentType={paymentType}
                                        message={message}
                                        amount={amount}
                                        remainingAmount={remainingAmount}
                                        selection={selection}
                                        total_bill_amount={total_bill_amount}
                                        load_control_num={getControlNumber()}
                                    />}

                                </div>
                                <div className="toolbar toolbar-bottom" role="toolbar" style={{ textAlign: "right" }}>
                                    <LoaderButton
                                        className="btn btn-chartreuse justify-content-center "
                                        loading={loading}
                                        onButtonClick={handleSubmit}
                                        name={formatMessage({ id: "app.submit" })}
                                    />
                                </div>
                                {error && !errorStatus && <ErrornDialog
                                    error="Sorry you are experiencing an unknown issue. For immediate assistance, please contact our Contact Support Center at (855)752-2878 to speak with an agent. Thank you."
                                    errorresponse={errorresponse}
                                    open
                                />}
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default injectIntl(PaymentMethod);
